<template>
  <div class="page-content">
    <div class="order-detail">
      <!-- 拼团购买 -->
      <div class="order-group" v-if="detail && detail.order_info && detail.order_info.order_prom_type == 1221">
        <div class="st-name">
          <div class="left">
            <div class="name">
              <img src="../../assets/images/icon_car.png" alt="">
              <span>{{detail.team_detail.store_name}}</span>
            </div>
            <div class="order-number">订单编号：{{detail.order_info.order_sn}}</div>
          </div>
          <div class="heads">
            <img v-for="(item, index) in detail.teamHead" :src="item" alt="">
          </div>
        </div>
        <div class="class-type">
          <div class="top">
            <span>{{detail.team_detail.goods_name}}</span>
            <div class="group">拼团</div>
          </div>
          <div class="mid">
            <div class="tag">{{detail.team_detail.car_2distribution}}</div>
            <div class="tag">{{detail.team_detail.car_take}}</div>
            <div class="tag">{{detail.team_detail.time_long}}天拿本</div>
          </div>
          <div class="bot">
            <span class="old-price"><em class="money">￥{{detail.team_detail.shop_price}}</em>元</span>
            <span class="group-price">{{detail.team_detail.team_user_count}}人团：￥{{detail.team_detail.group_price}}元</span>
          </div>
        </div>
        <div class="order-money">
          <div class="btn" @click="cancelOrder">取消订单</div>
          <span>￥{{detail && detail.order_goods && (detail.order_goods.goods_price * goodsNum).toFixed(2) || '0.00'}}元
          </span>
        </div>
      </div>
      <!-- 报名学车 -->
      <div class="order-single" v-if="detail && detail.order_info && detail.order_info.order_prom_type == 1219 && detail.good">
        <div class="st-name">
          <div class="name">
            <img src="../../assets/images/icon_car.png" alt="">
            <span>{{detail.good.goods_name}}</span>
          </div>
          <div class="order-number">订单编号：{{detail.order_info.order_sn}}</div>
        </div>
        <div class="class-type">
          <div class="top">
            <span>{{detail.good.cat_id1_name}}{{detail.good.goods_name}}</span>
            <span class="price">￥{{detail.good.shop_price}}元</span>
          </div>
          <div class="mid">
            <div class="tag">{{detail.good.cat_id2_name}}</div>
            <div class="tag">{{detail.good.cat_id4_name}}</div>
            <div class="tag">{{detail.good.time_long}}天拿本</div>
          </div>
          <div class="bot">{{detail.good.time_long}}天拿本 {{detail.good.cat_id4_name}} {{detail.good.cat_id3_name}}</div>
        </div>
        <div class="order-money">
          <div class="btn" @click="cancelOrder">取消订单</div>
          <span>￥{{
              detail && detail.order_goods && (detail.order_goods.goods_price * goodsNum).toFixed(2) || '0.00'
            }}元
          </span>
        </div>
      </div>
      <!-- 购买优惠券 -->
      <div class="order-coupon" v-if="detail && detail.order_info && detail.order_info.order_prom_type == 1223">
        <div class="st-name">
          <div class="name">
            <img src="../../assets/images/icon_bd.png" alt="">
            <span v-if="detail && detail.coupon_car && detail.coupon_car.type ==2">平台优惠券</span>
            <span v-if="detail && detail.coupon_car && detail.coupon_car.type ==1">平台优惠券</span>
          </div>
          <div class="order-number">订单编号：{{detail.order_info.order_sn}}</div>
        </div>
        <div class="class-type">
          <div class="top">
            <span>{{detail.coupon_car.name}}</span>
            <div class="vouchers">券</div>
          </div>
          <div class="mid">
            <div class="tag">{{detail.coupon_car.short_name}}</div>
          </div>
        </div>
        <div class="order-money">
          <div class="btn" @click="cancelOrder">取消订单</div>
          <span>￥{{
              detail && detail.order_goods && (detail.order_goods.goods_price * goodsNum).toFixed(2) || '0.00'
            }}元
          </span>
        </div>
      </div>
      <!-- 购买礼物 -->
      <div class="order-gift" v-if="detail && detail.order_info && detail.order_info.order_prom_type == 1225">
        <div class="order-number">
          <img src="../../assets/images/icon_bd.png" alt="">
          <span>订单编号：{{detail.order_info.order_sn}}</span>
        </div>
        <div class="gift-name">
          <img :src="detail.order_goods.original_img" alt="" class="gift-img">
          <div class="info">
            <div class="top">
              <span>{{ detail.order_goods.goods_name }}(打赏{{ detail.order_info.consignee }})</span>
              <span class="price">￥{{ detail.order_goods.goods_price }}<em>元</em></span>
            </div>
            <div class="bot">
              <div class="opration">
                <div class="minus" :class="{'disable': goodsNum == 1}" @click="opMinus">-</div>
                <div class="number">{{ goodsNum }}</div>
                <div class="add" @click="opAdd">+</div>
              </div>
            </div>
          </div>
        </div>
        <div class="order-money">
          <div class="btn" @click="cancelOrder">取消订单</div>
          <span>￥{{
              detail && detail.order_goods && (detail.order_goods.goods_price * goodsNum).toFixed(2) || '0.00'
            }}元
          </span>
        </div>
      </div>
    </div>
    <div class="pay-type">
      <div class="content">
        <div class="wx-pay" v-if="is_weix">
          <span>微信支付(推荐)</span>
          <nut-radio v-model="payType" :label="'weixin'"></nut-radio>
        </div>
        <div class="zhb-pay">
          <span>支付宝</span>
          <nut-radio v-model="payType" :label="'alipayMobile'"></nut-radio>
        </div>
      </div>
    </div>
    <div class="balance-pay" >
      <div class="content">
        <span>使用余额￥{{ detail && detail.user_wallet && parseFloat(detail.user_wallet.balance).toFixed(2) || '0.00' }}</span>
        <nut-checkbox  :disabled="!detail || !detail.user_wallet || detail.user_wallet.balance <=0" v-model="use_balance"></nut-checkbox>
<!--         <nut-radio :disabled="!detail || !detail.user_wallet || detail.user_wallet.balance <=0" v-model="use_balance"></nut-radio>-->
      </div>
    </div>
    <div class="footer">
      <div class="pay-money">实付：<span>￥{{ payMoney || '0.00'}}元</span></div>
      <div class="btn" @click="routerToPayResult()">去支付</div>
    </div>
  </div>
</template>

<script>
import cache from "../../utils/cache";

export default {
  name: 'SureOrder',
  components: {},
  data() {
    return {
      order_id: 0,
      detail: {},
      goodsNum: 1,//商品数量
      payType: 'weixin',//支付方式 weixin  alipayMobile  use_balance
      is_weix:false,
      use_balance:false,
    }
  },
  created() {
    //缓存一下订单ID,防止页面刷新
    if (this.$route.query.order_id) {
      this.order_id = this.$route.query.order_id;
      cache.set('sure_order_id', this.order_id);
    } else {
      this.order_id = cache.get('sure_order_id');
    }
    //获取用户微信环境
    this.environment_info();
    window.document.title='订单确认-车之驭'
  },
  computed:{
    payMoney(){
      let money = 0.00;
      if(this.detail && this.detail.order_goods ){
        money = this.detail.order_goods.goods_price * this.goodsNum
      }
      if(this.use_balance && this.detail && this.detail.user_wallet ){
        //money-= this.detail.user_wallet.balance;
      }

      if(money<=0){
        money = 0.00;
      }
      return money.toFixed(2);
    }
  },
  methods: {
    environment_info(){
      var info = cache.get('environment_info');
      if(info == null){
        this.$ajax.get('m/trade/get_environment_info',{}).then(re=>{
          this.is_weix = re.is_wx
          cache.set('environment_info',JSON.stringify(re))
        })
      }else {
        info = JSON.parse(info);
        this.is_weix = info.is_wx;
      }
    },
    // 初始化数据
    initData() {

      this.$ajax.get('m/trade/add_order_info', {
        id: this.order_id
      }).then(detail => {
        this.detail = detail;
        this.goodsNum = detail.order_goods.goods_num;
        this.payType = detail.order_info.pay_code ? detail.order_info.pay_code : 'weixin';
        if(!this.is_weix){
          this.payType = 'alipayMobile';
        }
        document.title = '确认订单';
      })


    },
    // 购买数量加减
    opMinus() {
      if (this.goodsNum > 1) {
        this.goodsNum--;
      }
    },
    opAdd() {
      this.goodsNum++;
    },
    /**
     * 支付并且跳转支付结果
     * @param {number} id - 订单id
     * @param {number} orderType - 订单类型
     */
    routerToPayResult() {
      this.$ajax.get('m/Payment/getCode', {
        pay_code: this.payType,
        num: this.goodsNum,
        order_id: this.order_id,
        use_balance:this.use_balance
      }).then(res => {
        if (res.url) {
          window.location.href = res.url;
        }
      })
    },
    //取消订单
    cancelOrder(){
      this.$ajax.get('m/trade/cancel_order',{
        order_id: this.order_id
      }).then(res=>{
        this.$router.push({name: 'Home'});
      })
    },
  },
  mounted() {
    this.initData();
  },
}
</script>

<style lang="less" scoped>

.page-content {
  width: 100%;
  box-sizing: border-box;
  padding-top: 15px;

  .order-detail {
    width: 100%;
    box-sizing: border-box;
    padding: 0 15px;

    .order-group {
      width: 100%;
      height: 100%;
      box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.08);
      border-radius: 3px;

      .st-name {
        width: 100%;
        box-sizing: border-box;
        padding: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px #f1efef solid;

        .left {
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .name {
            display: flex;
            align-items: center;

            span {
              margin-left: 5px;
              font-size: 15px;
              color: #333;
            }
          }

          .order-number {
            box-sizing: border-box;
            padding-left: 19px;
            font-size: 14px;
            color: #999;
            margin-top: 5px;
          }
        }

        .heads {
          height: 30px;
          display: flex;

          img {
            width: 30px;
            height: 30px;
            object-fit: cover;
            border-radius: 50%;
            box-sizing: border-box;
            margin-left: -8px;
          }
        }
      }

      .class-type {
        width: 100%;
        box-sizing: border-box;
        padding: 10px;
        border-bottom: 1px #f1efef solid;

        .top {
          width: 100%;
          display: flex;
          align-items: center;

          span {
            font-size: 15px;
            color: #333;
          }

          .group {
            width: 32px;
            height: 20px;
            background-color: #FF808E;
            border-radius: 3px;
            line-height: 20px;
            text-align: center;
            font-size: 12px;
            color: #fff;
            margin-left: 5px;
          }
        }

        .mid {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          margin-top: 10px;

          .tag {
            height: 20px;
            line-height: 20px;
            background-color: #F8F8F8;
            border-radius: 3px;
            font-size: 12px;
            color: #666;
            margin-right: 5px;
            box-sizing: border-box;
            padding: 0 5px;
          }
        }

        .bot {
          width: 100%;
          margin-top: 10px;
          display: flex;
          align-items: center;

          .old-price {
            font-size: 14px;
            color: #999;
            margin-right: 10px;

            .money {
              font-style: normal;
              text-decoration: line-through;
              margin-right: 3px;
            }
          }

          .group-price {
            font-size: 14px;
            color: #EB273B;
          }
        }
      }

      .order-money {
        width: 100%;
        box-sizing: border-box;
        padding: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .btn {
          width: 68px;
          height: 28px;
          line-height: 28px;
          text-align: center;
          border: 1px #eae8e8 solid;
          border-radius: 15px;
          font-size: 12px;
          color: #666;
        }

        span {
          font-size: 14px;
          color: #EB273B;
        }
      }
    }

    .order-single {
      width: 100%;
      height: 100%;
      box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.08);
      border-radius: 3px;

      .st-name {
        width: 100%;
        box-sizing: border-box;
        padding: 10px;
        border-bottom: 1px #f1efef solid;

        .name {
          display: flex;
          align-items: center;

          span {
            margin-left: 5px;
            font-size: 15px;
            color: #333;
          }
        }

        .order-number {
          box-sizing: border-box;
          padding-left: 19px;
          font-size: 14px;
          color: #999;
          margin-top: 5px;
        }
      }

      .class-type {
        width: 100%;
        box-sizing: border-box;
        padding: 10px;
        border-bottom: 1px #f1efef solid;

        .top {
          width: 100%;
          display: flex;
          align-items: center;
          color: #333;

          span {
            font-size: 15px;
          }

          .price {
            font-size: 14px;
          }
        }

        .mid {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          margin-top: 10px;

          .tag {
            height: 20px;
            line-height: 20px;
            background-color: #F8F8F8;
            border-radius: 3px;
            font-size: 12px;
            color: #666;
            margin-right: 5px;
            box-sizing: border-box;
            padding: 0 5px;
          }
        }

        .bot {
          width: 100%;
          margin-top: 10px;
          font-size: 14px;
          color: #666;
        }
      }

      .order-money {
        width: 100%;
        box-sizing: border-box;
        padding: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .btn {
          width: 68px;
          height: 28px;
          line-height: 28px;
          text-align: center;
          border: 1px #a5a0a0 solid;
          border-radius: 15px;
          font-size: 12px;
          color: #666;
        }

        span {
          font-size: 14px;
          color: #EB273B;
        }
      }
    }

    .order-coupon {
      width: 100%;
      height: 100%;
      box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.08);
      border-radius: 3px;

      .st-name {
        width: 100%;
        box-sizing: border-box;
        padding: 10px;
        border-bottom: 1px #f1efef solid;

        .name {
          display: flex;
          align-items: center;

          span {
            margin-left: 5px;
            font-size: 15px;
            color: #333;
          }
        }

        .order-number {
          box-sizing: border-box;
          padding-left: 19px;
          font-size: 14px;
          color: #999;
          margin-top: 5px;
        }
      }

      .class-type {
        width: 100%;
        box-sizing: border-box;
        padding: 10px;
        border-bottom: 1px #f1efef solid;

        .top {
          width: 100%;
          display: flex;
          align-items: center;

          span {
            font-size: 15px;
            color: #333;
          }

          .vouchers {
            width: 32px;
            height: 20px;
            background-color: #6FCBF3;
            border-radius: 3px;
            line-height: 20px;
            text-align: center;
            font-size: 12px;
            color: #fff;
            margin-left: 5px;
          }
        }

        .mid {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          margin-top: 10px;

          .tag {
            height: 20px;
            line-height: 20px;
            background-color: #F8F8F8;
            border-radius: 3px;
            font-size: 12px;
            color: #666;
            margin-right: 5px;
            box-sizing: border-box;
            padding: 0 5px;
          }
        }
      }

      .order-money {
        width: 100%;
        box-sizing: border-box;
        padding: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .btn {
          width: 68px;
          height: 28px;
          line-height: 28px;
          text-align: center;
          border: 1px #a5a0a0 solid;
          border-radius: 15px;
          font-size: 12px;
          color: #666;
        }

        span {
          font-size: 14px;
          color: #EB273B;
        }
      }
    }

    .order-gift {
      width: 100%;
      height: 100%;
      box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.08);
      border-radius: 3px;

      .order-number {
        width: 100%;
        height: 42px;
        box-sizing: border-box;
        padding: 10px;
        border-bottom: 1px #f1efef solid;
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #999;

        img {
          margin-right: 5px;
        }
      }

      .gift-name {
        width: 100%;
        box-sizing: border-box;
        padding: 10px;
        border-bottom: 1px #f1efef solid;
        display: flex;

        .gift-img {
          width: 60px;
          height: 60px;
          object-fit: cover;
          margin-right: 10px;
        }

        .info {
          width: 60%;
          flex: 1;

          .top {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 15px;
            color: #333;

            .price {
              font-size: 18px;

              em {
                font-style: normal;
                font-size: 12px;
              }
            }
          }

          .bot {
            width: 100%;
            margin-top: 10px;
            display: flex;
            justify-content: flex-end;

            .opration {
              height: -26px;
              display: flex;
              border: 1px #ccc solid;
              border-radius: 3px;

              .minus, .add {
                width: 26px;
                height: 100%;
                line-height: 26px;
                text-align: center;
                font-size: 20px;
                color: #333;
              }

              .minus.disable {
                color: #ccc;
              }

              .number {
                box-sizing: border-box;
                padding: 0 11px;
                height: 100%;
                line-height: 26px;
                font-size: 15px;
                color: #333;
                border-left: 1px #ccc solid;
                border-right: 1px #ccc solid;
              }
            }
          }
        }
      }

      .order-money {
        width: 100%;
        box-sizing: border-box;
        padding: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .btn {
          width: 68px;
          height: 28px;
          line-height: 28px;
          text-align: center;
          border: 1px #a5a0a0 solid;
          border-radius: 15px;
          font-size: 12px;
          color: #666;
        }

        span {
          font-size: 14px;
          color: #EB273B;
        }
      }
    }
  }

  .pay-type {
    width: 100%;
    box-sizing: border-box;
    padding: 0 15px;
    margin-top: 15px;

    .content {
      width: 100%;
      height: 100%;
      box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.08);
      border-radius: 3px;

      div {
        width: 100%;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 10px;

        span {
          font-size: 15px;
          color: #333;
        }
      }

      .wx-pay {
        border-bottom: 1px #f1efef solid;
      }
    }
  }

  .balance-pay {
    width: 100%;
    box-sizing: border-box;
    padding: 0 15px;
    margin-top: 15px;

    .content {
      width: 100%;
      height: 50px;
      box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.08);
      border-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 0 10px;

      span {
        font-size: 15px;
        color: #333;
      }
    }
  }

  .footer {
    width: 100%;
    height: 60px;
    box-sizing: border-box;
    padding: 0 15px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    border-top: 1px #E2E2E2 solid;
    position: fixed;
    bottom: 0;
    left: 0;

    .pay-money {
      font-size: 14px;
      color: #666;

      span {
        color: #EB273B;
      }
    }

    .btn {
      width: 140px;
      height: 40px;
      background: linear-gradient(45deg, rgba(60, 67, 236, 1) 0%, rgba(0, 194, 255, 1) 100%);
      border-radius: 25px;
      line-height: 40px;
      text-align: center;
      font-size: 15px;
      font-weight: bold;
      color: #fff;
      margin-left: 10px;
    }
  }
}

/deep/ .nut-radio.nut-radio-size-base input {
  width: 16px;
  height: 16px;
}


/deep/ .nut-radio input:checked {
  background-color: #3C43EC;
  border-color: #3C43EC;
}

/deep/ .nut-checkbox input {
  border-radius: 100%;
  width: 16px;
  height: 16px;
}
/deep/ .nut-checkbox input:checked {
  background-color: #3C43EC;
  border-color: #3C43EC;
}

</style>
